import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { TeiHubLinkProductsModel } from "features/hublink/core/domain/tei-hub-link.model";
import {
  GetTeiHubLinkProductsResponse,
  GetTeiHubLinkProductsRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkProducts {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkProducts;
  message: string;
  data: TeiHubLinkProductsModel | undefined;
}

const initialState: InitialState = {
  status: TeiHubLinkProducts.initial,
  message: "",
  data: undefined,
};

export const teiHubLinkProducts = createAsyncThunk(
  "teiHubLinkProducts",
  async (_, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkProductsResponse =
        await GetTeiHubLinkProductsRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkProductsSlice = createSlice({
  name: "teiHubLinkProducts",
  initialState,
  reducers: {
    resetTeiHubLinkProducts: (state) => {
      state.status = TeiHubLinkProducts.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkProducts.pending, (state) => {
        state.status = TeiHubLinkProducts.inProgress;
      })
      .addCase(teiHubLinkProducts.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = TeiHubLinkProducts.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(teiHubLinkProducts.rejected, (state, action) => {
        state.status = TeiHubLinkProducts.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectTeiHubLinkProducts = (state: RootState) =>
  state.teiHubLinkProducts;

export const { resetTeiHubLinkProducts } = teiHubLinkProductsSlice.actions;
export default teiHubLinkProductsSlice.reducer;
